<template>
	<el-row class="googlereports">
		<el-col :span="24" class="googlereports-select">
			<client-module moduletitle="Google Ads广告报告">
				<sky-dropdown-select
					slot="customHint"
					class="site-list"
					@change="changeSite"
					v-model="serviceId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
				<div class="switch-content">
					<div class="time-switch">
						<skydropdown-select :options="groups" @change="change" :value="selecttimetype">
						</skydropdown-select>
						<!-- 日期选择器 -->
						<el-date-picker
							v-model="startDate"
							:type="pickerType"
							:format="format"
							:disabled="disabled"
							clearable
							placeholder="请选择日期"
							:picker-options="pickerOptions"
							@change="dataChange"
						>
						</el-date-picker>
						<div class="time-date" v-if="startDate">
							<span>{{ startDate }}</span>
							<span>至</span>
							<span>{{ endDate }}</span>
						</div>
					</div>
					<sky-select
						class="language-switch"
						:disabled="disabled"
						v-model="language"
						@change="languageChange"
						:options="reportList"
					>
					</sky-select>
				</div>
			</client-module>
		</el-col>
		<el-col :span="24" class="data-overview">
			<googleorsocial :googleorsocial="googleadvertising">
				<div slot="title">数据总览</div>
				<div slot="bottom-name">相比{{ dataPeriod }}</div>
			</googleorsocial>
		</el-col>
		<el-col :span="24" class="charts">
			<div class="charts-tabs">
				<div
					:class="activeClass == 'campaign' ? 'active' : ''"
					@click="handleClick('campaign', '广告系列')"
				>
					广告系列
				</div>
				<div :class="activeClass == 'geo' ? 'active' : ''" @click="handleClick('geo', '区域')">
					区域
				</div>
				<div
					:class="activeClass == 'keyword' ? 'active' : ''"
					@click="handleClick('keyword', '关键词')"
				>
					关键词
				</div>
				<div
					:class="activeClass == 'device' ? 'active' : ''"
					@click="handleClick('device', '设备')"
				>
					设备
				</div>
			</div>
			<div class="chart">
				<div class="hint-title">
					{{ tishiName }}
					<el-tooltip class="item" effect="dark" :content="interpretation" placement="bottom-start">
						<ig-icon name="tishi"></ig-icon>
					</el-tooltip>
				</div>
				<div class="chartBox" :span="24">
					<div class="bar">
						<advertising-series
							:condition="condition"
							@googlereports="setselectNum"
						></advertising-series>
					</div>
					<div class="pie">
						<advertising-series-pie
							:condition="conditionPie"
							@googlereportspie="setselectNumPie"
						></advertising-series-pie>
					</div>
				</div>
			</div>
		</el-col>
		<el-col :span="24" class="google-list" v-show="activeClass != 'search'">
			<client-module class="clientmodule">
				<div slot="moduletitle">
					<div v-if="activeName != '设备'">{{ activeName }}{{ selectName }}TOP50详情</div>
					<div v-else class="moduletitle">
						<div class="sumTitle">设备详情</div>
						<el-select v-model="selectValue" @change="selectChange" size="mini">
							<el-option
								v-for="item in selectOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
				</div>
				<el-button
					:disabled="disabled"
					type="primary"
					slot="event"
					size="mini"
					@click="googlederive"
					v-if="dataList && dataList.length"
					>下载</el-button
				>
				<data-list
					:table-style="{ name: 'webclient' }"
					:data="dataList"
					:columns="column"
					:loading="loading"
				></data-list>
			</client-module>
		</el-col>
		<dialog-form
			:dialogVisible="showDoalog"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="val => (showDoalog = val)"
		>
			<data-list
				slot="main"
				height="550"
				:table-style="{ name: 'webclient' }"
				:data="formInquiryData"
				:columns="formInquiryColumn"
				:loading="formInquiryLoading"
			></data-list>
		</dialog-form>
	</el-row>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import googleorsocial from '@/components/client/googleorsocial/googleorsocial';
import advertisingSeries from '@/components/client/clientCharts/advertising-series';
import advertisingSeriesPie from '@/components/client/clientCharts/advertising-series-pie';
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { getWeekTime, transferDate, GetMonthStr } from '@/utils/index.js';
import filters from '@/mixins/filters.js';
import { getDateRegion } from '@/common/util.js';
// import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'
import website from '@/backend/services/website/website.js';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import { mapGetters } from 'vuex';
import dialogForm from '@/components/dialogForm/dialogForm';

export default {
	data() {
		let that = this;
		return {
			googledata: {},
			googledataPie: {},
			loading: false,
			googleadvertising: {},
			activeClass: 'campaign',
			dataType: 'campaign',
			activeName: '广告系列',
			selectName: '展示次数',
			tishiName: '广告系列',
			interpretation:
				'由一组使用相同的预算、地理位置定位和其他设置的广告组（广告、关键字和出价）组成。广告系列通常用于将您提供的产品或服务进行归类。',
			condition: {},
			conditionPie: {},
			groups: [],
			selecttimetype: 'WEEKLY',
			selecttime: '',
			selectNum: 'IMPRESSIONS',
			selectNumPie: 'IMPRESSIONS',
			format: 'yyyy 第 WW 周',
			startDate: '',
			endDate: '',
			dataList: [],
			disabled: false,
			column: [],
			pickerOptions: {
				firstDayOfWeek: 1,
				disabledDate(time) {
					return that.dealDisabledDate(time);
				},
			},
			pickerType: 'week',
			DailyOlData: '',
			WeeklyOlData: '',
			MonthlyOlData: '',
			dataPeriod: '前一周',
			noreaddata: '0',
			activeSelectData: [],
			statSubmitlength: 0,
			serviceId: '',
			websiteList: [],
			language: '1',
			reportList: [
				{ label: '整体报告', value: '1' },
				{ label: '西班牙语', value: '131010' },
			],
			showDoalog: false,
			attributes: {
				title: '',
			},
			formInquiryData: [],
			formInquiryColumn: [],
			formInquiryLoading: false,
			selectValue: 1,
			selectOptions: [
				{ value: 1, label: '汇总数据' },
				{ value: 2, label: '按广告系列细分' },
			],
		};
	},
	computed: {
		...mapGetters(['customerId']),
	},
	methods: {
		setGroups(val) {
			this.groups = [
				{
					label: '日报',
					value: 'DAILY',
					disabled: val,
				},
				{
					label: '周报',
					value: 'WEEKLY',
					disabled: val,
				},
				{
					label: '月报',
					value: 'MONTHLY',
					disabled: val,
				},
			];
		},
		// 网站下拉数据
		async getWebsite(id) {
			try {
				let result = await getWebsiteByCustomer({
					customerId: id,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.serviceId = result.data[0].id;

				this.getWeek();
			} catch (error) {
				this.getWeek();
			}
		},
		// 切换网站
		changeSite() {
			this.googlereports();
			this.googlereportsPie();
		},
		// 语种切换
		languageChange() {
			this.googlereports();
			this.googlereportsPie();
		},
		setselectNum(val) {
			this.selectNum = val;
			this.selectName = this.selectSwitch(val);
			this.googlereports();
		},
		selectSwitch(val) {
			switch (val) {
				case 'IMPRESSIONS':
					return '展示次数';
				case 'CLICKS':
					return '点击次数';
				case 'COST':
					return '消耗';
			}
		},
		// 获取谷歌报告
		async googlereports() {
			let { startDate, endDate, selecttimetype, selectNum, customerId, serviceId, language } = this;
			try {
				let res = await website.googlereports({
					customerId,
					serviceId,
					startDate,
					endDate,
					type: selecttimetype,
					language,
					sortDTO: {
						field: selectNum,
						sort: 'DESC',
					},
				});
				this.selectValue = 1;
				this.googledata = res.data;
				this.googledataPie = Object.assign({}, res.data);
				this.setgoogleadvertising(res.data);
				this.setCondition();
				this.setConditionPie();
			} catch (error) {
				this.googledata = {};
				this.googledataPie = {};
				this.setgoogleadvertising();
			}
		},
		setselectNumPie(val) {
			this.selectNumPie = val;
			this.googlereportsPie();
		},
		async googlereportsPie() {
			let { startDate, endDate, selecttimetype, selectNumPie, customerId, serviceId, language } =
				this;
			try {
				let res = await website.googlereports({
					customerId,
					serviceId,
					startDate,
					endDate,
					type: selecttimetype,
					language,
					sortDTO: {
						field: selectNumPie,
						sort: 'DESC',
					},
				});
				this.googledataPie = Object.assign({}, res.data);
				this.setConditionPie();
			} catch (error) {
				this.googledataPie = {};
			}
		},
		// 配置condition
		setCondition() {
			let tabName = this.activeClass == 'device' ? 'deviceList' : this.activeClass + 'ChartList';
			let that = this;
			this.condition = {
				startDate: that.startDate,
				endDate: that.endDate,
				type: that.selecttimetype,
				sortDTO: {
					field: that.selectNum,
					sort: 'DESC',
				},
				tabItem: that.activeClass,
				tabName: that.activeName,
				data: that.googledata[tabName],
			};
		},
		setConditionPie() {
			let tabName = this.activeClass == 'device' ? 'deviceList' : this.activeClass + 'ChartList';
			let that = this;
			this.conditionPie = {
				startDate: that.startDate,
				endDate: that.endDate,
				type: that.selecttimetype,
				sortDTO: {
					field: that.selectNumPie,
					sort: 'DESC',
				},
				tabItem: that.activeClass,
				tabName: that.activeName,
				data: that.googledataPie[tabName],
			};
		},
		setgoogleadvertising(val = {}) {
			this.googleadvertising = {
				list: [
					{
						id: 1,
						title: '展示次数',
						icon: 'zhanshiliang',
						data: filters.filters.thousands(val.impressions),
						rate: filters.filters.number(Math.abs(val.impressionsRingRatio || 0)) + '%',
						state: val.impressionsRingRatio,
						message: {
							site: 'top-start',
							content:
								'⼴告的展示频率，⼴告在搜索结果⻚或 Google ⼴告⽹络中的其他⽹站上显示时，就计为⼀次展示',
						},
					},
					{
						id: 2,
						title: '点击率',
						icon: 'dianjilv',
						data: filters.filters.jojint(val.clickRate),
						rate: filters.filters.number(Math.abs(val.clickRingRatio || 0)) + '%',
						state: val.clickRingRatio,
						message: {
							site: 'top-start',
							content: '⼀个⽐率，表示在看过您⼴告的⽤户中有多少⽤户最后点击了⼴告',
						},
					},
					{
						id: 3,
						title: '总消耗（元）',
						icon: 'zongxiaohao',
						data: filters.filters.rmb(val.exchangeRateCost),
						rate: filters.filters.number(Math.abs(val.exchangeRateCostRingRatio || 0)) + '%',
						state: val.exchangeRateCostRingRatio,
						message: {
							site: 'top-start',
							content: '是指您在指定时间范围内所支出的总费用',
						},
					},
					{
						id: 4,
						title: '点击均价（元）',
						icon: 'dianjijunjia',
						data: filters.filters.rmb(val.clickOnAverage),
						rate: filters.filters.number(Math.abs(val.clickOnAverageRingRatio || 0)) + '%',
						state: val.clickOnAverageRingRatio,
						message: {
							site: 'top-start',
							content: '一个平均值，表示指定时间范围内，每次点击所支出的费用均值',
						},
					},
					{
						id: 5,
						title: '网站表单询盘',
						icon: 'liebiaoxunpan',
						iconBgc: {
							background: '#ddeef8',
						},
						data: filters.filters.thousands(val.inquiryTotal),
						rate: filters.filters.number(Math.abs(val.ratio || 0)) + '%',
						state: val.ratio,
						message: {
							site: 'top-start',
							content: '表示指定时间范围内，可以归因到谷歌广告的网站表单询盘数量',
						},
					},
				],
				title: '数据总览',
				type: 'google',
				bottom: true,
			};
		},
		// tab切换
		handleClick(val, name) {
			this.activeClass = val;
			let interpretation = {
				campaign:
					'由一组使用相同的预算、地理位置定位和其他设置的广告组（广告、关键字和出价）组成。广告系列通常用于将您提供的产品或服务进行归类。',
				geo: `通过 Google Ads 地理位置定位，您可以将自己的广告投放到所选地理位置：特定的国家/地区、某个国家/地区内的特定区域、某个地点周围一定半径内的区域，或者成组的地理位置，其中可以包括您感兴趣的地方、您的营业地点或者按受众特征划分的区域。`,
				keyword: '是指用来将您的广告和用户搜索的字词联系起来的字词或词组。',
				search:
					'搜索字词报告可列出用户在看到并点击您的广告之前所使用的搜索字词。您可以根据此报告找出用户极有可能使用的新搜索字词，并将其添加到关键字列表中。还可以寻找与您的业务不相关的搜索字词，将其添加为否定关键字，避免浪费资金。',
				device: '广告在不同设备上的投放效果，您可以根据实际情况调整不同设备的出价',
			};
			// 搜索词
			if (val == 'search') {
				this.tishiName = name;
				this.interpretation = interpretation[val];
				return false;
			} else {
				this.tishiName = name;
				this.activeName = name;
				this.dataType = val;
				this.interpretation = interpretation[val];
				let listName =
					this.activeClass == 'device' ? 'deviceList' : this.activeClass + 'StatisticsList';
				this.selectValue = val == 'device' ? 1 : 2;
				this.dataList = this.googledata[listName];
				this.setColumn(this.activeName);
				this.setCondition();
				this.setConditionPie();
			}
		},
		// 时间类型选择
		change(val) {
			this.selecttime = '';
			this.selecttimetype = val;
			switch (val) {
				case 'WEEKLY':
					this.pickerType = 'week';
					this.format = 'yyyy 第 WW 周';
					this.dataPeriod = '前一周';

					if (this.WeeklyOlData) {
						this.dataChange(this.WeeklyOlData);
					} else {
						this.getWeek();
						this.setCondition();
						this.setConditionPie();
					}
					break;
				case 'DAILY':
					this.pickerType = 'date';
					this.format = 'yyyy-MM-dd';
					this.dataPeriod = '前一天';

					if (this.DailyOlData) {
						this.dataChange(this.DailyOlData);
					} else {
						this.getDetailDay();
						this.googlereports();
						this.googlereportsPie();
						this.setCondition();
						this.setConditionPie();
					}
					break;
				case 'MONTHLY':
					this.pickerType = 'month';
					this.format = 'yyyy-MM';
					this.dataPeriod = '前一月';

					if (this.MonthlyOlData) {
						this.dataChange(this.MonthlyOlData);
					} else {
						this.getDetailMonth();
						this.googlereports();
						this.googlereportsPie();
						this.setCondition();
						this.setConditionPie();
					}
					break;
				default:
					this.pickerType = 'week';
					break;
			}
		},
		// 时间选择
		dataChange(val) {
			if (!val) {
				this.getWeek();
				this.googlereports();
				this.googlereportsPie();
				return false;
			}
			let { selecttimetype } = this;
			// 周报
			if (selecttimetype === 'WEEKLY') {
				let valChange = val.getTime() - 1 * 24 * 3600 * 1000;
				this.WeeklyOlData = new Date(valChange);
				// 处理月份结束日期
				let weekEnd = valChange + 6 * 24 * 3600 * 1000;
				weekEnd = transferDate(new Date(weekEnd));
				let time = transferDate(new Date(valChange));

				this.startDate = time;
				this.endDate = weekEnd;
			}
			// 日报
			if (selecttimetype === 'DAILY') {
				this.DailyOlData = val;
				let time = transferDate(val);

				this.startDate = time;
				this.endDate = time;
			}
			// 月报
			if (selecttimetype === 'MONTHLY') {
				this.MonthlyOlData = val;
				let time = transferDate(val);
				// 求指定月长度
				let M = val.getMonth() + 1;
				let Y = val.getFullYear();
				let lange = new Date(Y, M, 0).getDate();

				// 处理月份结束日期
				let arr = time.split('-');
				arr[2] = lange - 0;

				this.startDate = time;
				this.endDate = arr.join('-');
			}
			this.googlereports();
			this.googlereportsPie();
		},
		// 时间选择器返回限制
		dealDisabledDate(time) {
			let { selecttimetype } = this;
			if (selecttimetype === 'WEEKLY') {
				//按周日为一周的最后一天计算
				var week = new Date();
				//今天是这周的第几天
				var today = week.getDay() * 24 * 3600 * 1000;

				// 三个月的开始结束时间
				// let date = GetMonthStr(3, 'day')
				// let end = new Date(date.last).getTime()
				return time.getTime() > Date.now() - today; //|| time.getTime() < end
			}
			if (selecttimetype === 'DAILY') {
				// 三个月的开始结束时间
				let date = GetMonthStr(3, 'day');
				let start = new Date(date.now).getTime();
				// let end = new Date(date.last).getTime()
				return time.getTime() > start; //|| time.getTime() < end
			}
			if (selecttimetype === 'MONTHLY') {
				// 三个月的开始结束时间
				// let date = GetMonthStr(3, 'day')
				// let end = new Date(date.last).getTime()
				return time.getTime() > Date.now(); //|| time.getTime() < end
			}
		},
		// 获取时间初始值
		// 日报初始化
		getDetailDay() {
			this.startDate = getDateRegion('DAY').split('至')[0];
			this.endDate = getDateRegion('DAY').split('至')[1];
		},
		// 周报初始值
		getWeek() {
			this.startDate = getWeekTime('start');
			this.endDate = getWeekTime('end');

			this.googlereports();
			this.googlereportsPie();
		},
		// 月报初始化
		getDetailMonth() {
			this.startDate = getDateRegion('NEWMONTH').split('至')[0];
			this.endDate = getDateRegion('NEWMONTH').split('至')[1];
		},
		// 配置column
		setColumn(val) {
			let that = this;
			let column = [
				{
					label: val == '2' || val == '设备' ? '设备类型' : val,
					bind: val == '2' ? 'deviceName' : 'name',
					showHover: true,
				},
				{
					label: '展示次数',
					bind: 'impressions',
					align: 'right',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.thousands(val);
					},
				},
				{
					label: '展示占比',
					bind: 'impressionsRate',
					align: 'right',
					type: 'percentage',
					dataStyle(val) {
						return val + '%';
					},
				},
				{
					label: '点击次数',
					bind: 'clicks',
					align: 'right',
					type: 'percentage',
					dataStyle(val) {
						return filters.filters.thousands(val);
					},
				},
				{
					label: '点击率',
					bind: 'clickRate',
					align: 'right',
					type: 'percentage',
					dataStyle(val) {
						return val + '%';
					},
				},
				{
					label: '点击均价（元）',
					bind: 'clickOnAverage',
					align: 'right',
					type: 'percentage',
					style: {
						textAlign: 'right',
					},
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '消耗（元）',
					bind: 'exchangeRateCost',
					align: 'right',
					type: 'percentage',
					width: 150,
					style: {
						textAlign: 'right',
					},
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '消耗占比',
					bind: 'exchangeRateCostRate',
					align: 'right',
					type: 'percentage',
					width: 150,
					dataStyle(val) {
						return val + '%';
					},
				},
			];
			if (val === '广告系列' || val === '关键词') {
				column.splice(6, 0, {
					label: '询盘均价（元）',
					bind: 'inquiryOnAverage',
					type: 'percentage',
					align: 'right',
					dataStyle(val) {
						if (!val && val !== 0) return '-';
						return filters.filters.rmb(val);
					},
				});

				column.splice(6, 0, {
					label: '表单询盘数',
					bind: 'inquiryTotal',
					type: 'percentage',
					getStyle(val) {
						if (val) {
							return {
								color: '#3DA1FF',
								cursor: 'pointer',
							};
						} else {
							return {
								color: '#333',
							};
						}
					},
					dataStyle(val) {
						return val || '-';
					},
					webskip(val, row) {
						if (!val) return false;
						that.attributes.title = `"${row.name || '-'}"带来的网站表单询盘`;
						that.showFormInquiryList(row);
					},
				});
			}
			if (val == 2) {
				column.splice(1, 0, { label: '广告系列', bind: 'campaignName', showHover: true });
				column.splice(3, 1);
				column.splice(7, 1);
			}
			this.column = column;
		},
		// 下载数据
		async googlederive() {
			let res;
			if (this.activeClass == 'device' && this.selectValue == 2) {
				res = await website.campaign_deviceExport({
					startDate: this.startDate,
					endDate: this.endDate,
					serviceId: this.serviceId,
				});
			} else {
				res = await website.googlederive({
					id: this.customerId,
					dataType: this.dataType.toLocaleUpperCase(),
					startDate: this.startDate,
					endDate: this.endDate,
					language: this.language,
					type: this.selecttimetype,
					serviceId: this.serviceId,
					sortDTO: {
						field: this.selectNum,
						sort: 'DESC',
					},
				});
			}
			this.download(res.data, 'Google Ads广告报告');
		},
		download(val, name) {
			let blob = new Blob([val]);
			let url = window.URL.createObjectURL(blob);
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', `${name}【${this.startDate}至${this.endDate}】.xlsx`);
			document.body.appendChild(link);
			link.click();
		},
		async showFormInquiryList(row) {
			let { activeClass, startDate, endDate, serviceId } = this;
			let { campaignIdList, name } = row;
			let params = {};
			if (activeClass === 'campaign') {
				params = {
					adSeriesIdList: campaignIdList,
				};
			}
			if (activeClass === 'keyword') {
				params = {
					keyword: name,
				};
			}
			this.formInquiryLoading = true;
			try {
				this.setFormInquiryColumn();
				let res = await website.getFormInquiryList({
					beginTimeStr: startDate,
					endTimeStr: endDate,
					serviceId,
					displayStart: 1,
					displayLength: 100,
					...params,
				});
				this.formInquiryData = res.data.data;
				this.showDoalog = true;
				this.formInquiryLoading = false;
			} catch (err) {
				this.formInquiryLoading = false;
			}
		},
		setFormInquiryColumn() {
			this.formInquiryColumn = [
				{
					label: '留言时间',
					bind: 'inquiryTime',
					showOverflowTooltip: true,
				},
				{
					label: '地区',
					bind: 'region',
				},
				{
					label: '留言内容',
					bind: 'content',
					showOverflowTooltip: true,
				},
			];
		},
		async selectChange(val) {
			if (val == 2 && this.language == '1') {
				this.loading = true;
				this.setColumn(val);
				let res = await website.campaign_device({
					startDate: this.startDate,
					endDate: this.endDate,
					serviceId: this.serviceId,
				});
				this.dataList = res.data;
				this.loading = false;
			}
			if (val == 1) {
				this.handleClick('device', '设备');
			}
		},
	},
	watch: {
		customerId: {
			async handler(val) {
				let id = this.$route.query.id;
				let name = this.$route.query.name;
				if (id && name) {
					this.$store.commit('SET_CUSTOMERID', id);
					this.$store.commit('SET_CUSOMERNAME', name);
				}

				if (val || (id && name)) {
					this.disabled = false;
					this.setGroups(false);
					this.getWebsite(val);
				} else {
					this.disabled = true;
					this.setGroups(true);
					this.$message.warning('您需要先选择一个客户');
					this.$showCustomerDialog();
				}
			},
			immediate: true,
		},
		googledata: {
			handler(val) {
				let listName =
					this.activeClass == 'device' ? 'deviceList' : this.activeClass + 'StatisticsList';
				this.dataList = val[listName];
				this.setColumn(this.activeName);
				this.setgoogleadvertising(val);
				this.setCondition();
			},
			immediate: true,
			deep: true,
		},
	},
	components: {
		clientModule,
		googleorsocial,
		advertisingSeries,
		advertisingSeriesPie,
		skydropdownSelect,
		// filterPanel,
		skyDropdownSelect,
		skySelect,
		dialogForm,
	},
};
</script>

<style scoped lang="scss">
.el-row {
	.googlereports-select {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		margin-bottom: 10px;

		.site-list {
			margin-left: 20px;
		}

		.switch-content {
			display: flex;
		}

		.time-switch {
			width: 650px;
			height: 60px;
			display: flex;
			align-items: center;
			padding: 0 24px;

			.el-date-editor {
				margin-left: 52px;

				.el-range-separator {
					padding: 0;
				}
			}

			.time-date {
				color: #666;
				margin-left: 20px;
				font-size: 16px;
			}

			.el-dropdown {
				color: #5aa0ff;
			}
		}

		.language-switch {
			width: 350px;

			&::before {
				content: '报告切换';
				width: 150px;
			}
		}
	}

	.data-overview {
		height: 265px;
		background: #fff;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		margin-bottom: 20px;

		i {
			font-size: 12px;
			color: #999;
			margin-left: 5px;
		}
	}

	.charts {
		min-height: 620px;
		max-height: 1000px;
		background: #fff;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		margin-bottom: 20px;
		padding: 0 20px 20px 20px;

		.charts-tabs {
			width: 100%;
			height: 60px;
			line-height: 60px;
			padding: 0 14px;
			margin-bottom: 20px;
			border-bottom: 1px solid #e8e8e8;
			display: flex;
			justify-content: flex-start;

			div {
				height: 100%;
				padding: 0 10px;
				margin-right: 50px;
				font-size: 16px;
				font-weight: bold;
				color: #333;
				border-bottom: 2px solid transparent;
				user-select: none;
				cursor: pointer;
			}

			.active {
				color: #1890ff;
				border-bottom: 2px solid #1890ff;
			}
		}

		.chart {
			.hint-title {
				font-size: 16px;
				font-weight: bold;
				color: #333;
				line-height: 22px;
				margin-bottom: 20px;
				padding: 0 14px;

				i {
					font-size: 12px;
					color: #999;
					margin-left: 5px;
				}
			}

			.chartBox {
				display: flex;
				justify-content: space-between;
				align-items: center;
				// padding: 20px;
				.bar {
					width: 50%;
					box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
					border-radius: 4px;
					margin-right: 10px;
				}

				.pie {
					width: 50%;
					box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
					border-radius: 4px;
					margin-left: 10px;
				}
			}

			.search {
				width: 100%;
				margin: 0;

				.filter-panel {
					padding: 0 14px;
				}
			}
		}
	}

	.google-list {
		width: 100%;
		background-color: #fff;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;

		.clientmodule {
			.data-list {
				margin: 20px 27px 0;
			}
		}
	}
}
.moduletitle {
	display: flex;
	.sumTitle {
		margin-right: 10px;
	}
}
</style>
